import React from 'react';
import { IPreloadCacheContext } from 'framework/context/IPreloadCacheContext';

export const BebatDefaultCacheContext = React.createContext<IPreloadCacheContext<number>>(undefined as any);
